export default {
  "content": "<path d=\"M22.916 12.13l-4.293-4.293L5.49 20.97a.655.655 0 00-.2.48l-.707 3.346a.66.66 0 00.667.667h4.053a.626.626 0 00.467-.2L22.916 12.13zm3.947-3.947c.52-.52.52-1.36 0-1.88L24.45 3.89c-.52-.52-1.36-.52-1.88 0l-2.613 2.613 4.293 4.293 2.613-2.613z\"/><rect width=\"32\" height=\"3\" y=\"29\" rx=\"1.5\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "32",
    "fill": "#333",
    "viewBox": "0 0 32 32"
  }
};